import { QuillInstance, QuillStatic } from '../../types'

import { 
  findGestureBlot, 
  findClosestGestureEl, 
  registerGestureBlot,
} from './blot'
import { GESTURE_MODULE_NAME } from './constants'
import { GestureOptions } from './types'

export const registerGestureModule = (Quill: QuillStatic) => {
  const GestureBlot = registerGestureBlot(Quill)

  class GestureModule {
    constructor(quill: QuillInstance, options: GestureOptions = {}) {
      quill.root.addEventListener('click', (e) => {
        const target = e.target

        if (!target) {
          return
        }

        if (!(target instanceof HTMLElement)) {
          return
        }

        const closestEl = findClosestGestureEl(target)

        if (!closestEl) {
          return
        }

        const foundBlot = findGestureBlot(closestEl)

        if (!foundBlot) {
          return
        }

        if (!(foundBlot instanceof GestureBlot)) {
          return
        }

        /**
         * 클릭 이벤트 전파를 막아서 버튼이 클릭됐을 때 드롭다운이 닫히지 않도록 함
         */
        e.stopPropagation()

        options.onClick?.(closestEl, foundBlot.value().gesture)
      })
    }
  }

  Quill.register(`modules/${GESTURE_MODULE_NAME}`, GestureModule, true)

  return GestureModule
}
